<template>
  <div>
    <PCNavbar selectIndex="16"/>
    <MobileNavBar :currentActive="15" />
    <traceabilityManagementCategory/>
    <router-view></router-view>
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import traceabilityManagementCategory from '@/components/service_traceability_management_category-5/index.vue'
export default {
  components: {
    PCNavbar,
    MobileNavBar,
    traceabilityManagementCategory
  },
}
</script>

<style>
.el-timeline-item__timestamp{
  font-size: 0.9rem !important;
  padding: 1rem 0;
}
</style>